import React, {useEffect, useRef, useState} from 'react';
import {CompactPicker} from 'react-color';
import Popper from '@mui/material/Popper';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';

/* eslint-disable react/prop-types */
const ColorPicker = ({
                         open,
                         anchorEl,
                         applyColorCommand,
                         onClose
                     }) => {
    const [color, setColor] = useState('#000000');
    const pickerRef = useRef(null);

    useEffect(() => {
        if (!open) return;

        const handlePointerDownCapture = (event) => {
            const path = event.composedPath?.() ?? [];

            if (pickerRef.current && (path.includes(pickerRef.current) || pickerRef.current.contains(event.target))) {
                return;
            }

            if (anchorEl && (path.includes(anchorEl) || anchorEl.contains(event.target))) {
                return;
            }

            onClose();
        };

        const handleKeyDownCapture = (event) => {
            if (event.key === 'Escape') onClose();
        };

        window.addEventListener('pointerdown', handlePointerDownCapture, true);
        window.addEventListener('keydown', handleKeyDownCapture, true);

        return () => {
            window.removeEventListener('pointerdown', handlePointerDownCapture, true);
            window.removeEventListener('keydown', handleKeyDownCapture, true);
        };
    }, [open, anchorEl, onClose]);

    const handleChangeComplete = (c) => {
        setColor(c.hex);
        applyColorCommand(c.hex);
        onClose();
    };

    return (
        <Popper
            open={open}
            anchorEl={anchorEl}
            placement="bottom-start"
            disablePortal={false}
            modifiers={[{
                name: 'offset',
                options: {offset: [0, 8]}
            }]}
            style={{zIndex: 2000}}
        >
            <Paper elevation={6} ref={pickerRef}>
                <Box sx={{p: 1}}>
                    <CompactPicker color={color} onChangeComplete={handleChangeComplete}/>
                </Box>
            </Paper>
        </Popper>
    );
};

export default ColorPicker;
